import LoadingGif1 from "../../assets/loading/loading8.gif";

const Loading = (props) => {
  const width = props.width ? props.width : 200;
  const height = (width * 291) / 441;
  const text = props.text ? props.text : "در حال بارگذاری...";
  const showText = props.showText === undefined ? true : props.showText;
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
        }}
      >
        <img
          src={LoadingGif1}
          width={width}
          height={height}
          alt={"loading-gif"}
        />

        <p
          style={{
            display: showText ? "" : "none",
            marginTop: "-20px",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      </div>
    </>
  );
};

export default Loading;
